<div class="form-container">
  <form #f="ngForm" (ngSubmit)="onSubmit()">
    <div class="col-md-12" style="display: flex;">
      <div class="col-9">
        <div class="section-box">
          <h2>Details</h2>
         
            <label for="firstName" class="form-label labelReport">Team Name<span class="mandatory">*</span>:</label>
            <input matInput type="text" [(ngModel)]="team.teamName" #teamName="ngModel" pInputText pKeyFilter="alpha" [ngModelOptions]="{standalone: true}" class="form-control inputField" id="tname" placeholder="Team Name">
         
         
            <label for="teamLevel" class="form-label labelReport">Team Level:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="team.teamType" (change)="SelectLevel($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Level</option>
              <option [value]="1">1</option>
              <option [value]="2">2</option>
              <option [value]="3">3</option>
              <option [value]="4">4</option>
              <option [value]="5">5</option>
            </select>
            <label for="firstName" class="form-label labelReport">Engram Test Type<span class="mandatory">*</span>:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedEnngramType" (change)="selectEnngramType($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of enngramTest" [value]="item.id">
                {{ item.name }}
              </option>
            </select>
        </div>
        <div class="section-box">
          <h2>Diabetes</h2>
         
          
            <label for="firstName" class="form-label labelReport">Diabetes Type<span class="mandatory">*</span>:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedDiabetesType" (change)="selectDiabetesType($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of diabetesTypeArr" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
          
            <label for="firstName" class="form-label labelReport">Age of Diabetes (Years):</label>
            <input matInput type="text" [(ngModel)]="team.ageOfDibeties" #ageOfDibeties="ngModel" pInputText pKeyFilter="alpha" [ngModelOptions]="{standalone: true}" class="form-control inputField" id="tname" placeholder="Age of Diabetes">
          </div>
       
        <div class="section-box">
          <h2>User Type</h2>
        
            <label for="firstName" class="form-label labelReport">Doctor:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedDoctor" (change)="selectDoctor($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of allDoctors" [value]="item.id">
                {{ item.firstName }} {{ item.lastName }}
              </option>
            </select>
         
            <label for="memberAdvocate" class="form-label labelReport">Member Advocate<span class="mandatory">*</span>:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedMemberAdvocate" (change)="selectMemberAdvocate($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of allMemberAdvocate" [value]="item.id">
                {{ item.firstName }} {{ item.lastName }}
              </option>
            </select>
          
            <label for="fitnessInstructor" class="form-label labelReport">Fitness Instructor:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedFitnessInstructor" (change)="selectFitnessInstructor($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of allFitness" [value]="item.id">
                {{ item.firstName }} {{ item.lastName }}
              </option>
            </select>
          
            <label for="nutritionist" class="form-label labelReport">Nutritionist:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedNutritionist" (change)="selectNutritionist($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of allNutrient" [value]="item.id">
                {{ item.firstName }} {{ item.lastName }}
              </option>
            </select>
          
            <label for="physiotherapist" class="form-label labelReport">Psychologists:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedPhysiotherapist" (change)="selectPhysiotherapist($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option *ngFor="let item of allPhy" [value]="item.id">
                {{ item.firstName }} {{ item.lastName }}
              </option>
            </select>
           
        </div>
        <div class="section-box">
          <h2>Policy</h2>
         
            <label for="policy" class="form-label labelReport">Policy:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="selectedPolicy" (change)="selectPolicy($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose Option</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
        
        <div class="section-box">
          <h2>Address</h2>
          
            <label for="country" class="form-label labelReport">Country:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="country" (change)="getCountry($event)" [ngModelOptions]="{standalone: true}">
              <option value="india">India</option>
              <option value="United States">USA</option>
              <option value="Canada">Canada</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Australia">Australia</option>
            </select>
          
            <label for="state" class="form-label labelReport">State<span class="mandatory">*</span>:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="state" (change)="SelectedRow($event)" [ngModelOptions]="{standalone: true}">
              <option value="">Choose State</option>
              <option *ngFor="let item of states" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
          
            <label for="city" class="form-label labelReport">City<span class="mandatory">*</span>:</label>
            <select class="form-control inputField" style="padding:8px 23px;" [(ngModel)]="city" [ngModelOptions]="{standalone: true}">
              <option value="">Choose City</option>
              <option *ngFor="let item of cities" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
       
        </div>
        <div class="col-md-12 form-group float mt-4">
          <button type="submit" class="btn btn-primary btn mt-4 color">Save</button>
        </div>
      </div>
    </div>
  </form>
</div>
